import React from 'react';
import styles from './Hero.module.css';

interface HeroProps {
  firstName: string;
  lastName: string;
  portraitSrc: string;
  portraitAlt: string;
  issueInfo: string;
  coverStory: string;
}

export const Hero: React.FC<HeroProps> = ({
  firstName,
  lastName,
  portraitSrc,
  portraitAlt,
  issueInfo,
  coverStory
}) => {
  return (
    <section id="cover" className={styles.magazineCover}>
      <div className={styles.coverContent}>
        <div className={styles.portraitContainer}>
          <img
            src={portraitSrc}
            alt={portraitAlt}
            className={styles.circularPortrait}
          />
        </div>
        <h1 className={styles.nameContainer}>
          <span className={styles.firstName}>{firstName}</span>
          <span className={styles.lastName}>{lastName}</span>
        </h1>
        <div className={styles.issueInfo}>{issueInfo}</div>
        <h2 className={styles.coverStory}>
          {coverStory.split(' ').map((word, index, arr) => (
            <React.Fragment key={index}>
              {word}
              {index === Math.floor(arr.length / 2) - 1 && <br />}
              {index !== arr.length - 1 && index !== Math.floor(arr.length / 2) - 1 && ' '}
            </React.Fragment>
          ))}
        </h2>
      </div>
    </section>
  );
};
